import { Icon } from '@docs/kd-d2c-components';
import { eed_web_icon_global_06_state_cuowu_area } from '@src/assets/icons';
import React from 'react';
import './index.less';

const DEFAULT_CLASSNAME = 'kim-ui-circle-progress';

export interface CircleProgressProps {
  /**
   * 圆形的总宽度
   */
  width?: number;
  /**
   * 进度百分比（0-100）
   */
  percent: number;
  /**
   * 中间icon宽度
   */
  iconWidth?: number;
  /**
   * 点击icon
   */
  onClickIcon?: () => void;
  /**
   * 进度条宽度
   */
  strokeWidth?: number;
  /**
   * 线条的颜色
   */
  strokeColor?: string;
  /**
   * 线条背景的颜色
   */
  strokeColorBg?: string;
}

export const CircleProgress = (props: CircleProgressProps) => {
  const {
    width = 22,
    percent = 50,
    iconWidth,
    strokeColor,
    strokeWidth = 2,
    strokeColorBg,
    onClickIcon,
  } = props;
  // 圆环起始点和半径
  const cx = width / 2;
  const cy = width / 2;
  const r = width / 2 - strokeWidth;

  const style = {
    width: width,
    height: width,
  };

  const getStrokeDasharray = (percent: number, r: number): string => {
    percent = percent / 100;
    const perimeter = Math.floor(Math.PI * 2 * r);
    return `${perimeter * percent} ${perimeter * (1 - percent)}`;
  };

  const handleIconClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClickIcon && onClickIcon();
  };

  return (
    <div className={DEFAULT_CLASSNAME} style={style}>
      <svg width={width} height={width} viewBox={`0 0 ${width} ${width}`}>
        <circle
          cx={cx}
          cy={cy}
          r={r}
          strokeWidth={strokeWidth}
          stroke={strokeColorBg}
          fill="transparent"
        ></circle>
        <circle
          cx={cx}
          cy={cy}
          r={r}
          strokeWidth={strokeWidth}
          stroke={strokeColor}
          strokeDasharray={getStrokeDasharray(percent, r)}
          fill="transparent"
          transform={`matrix(0,-1,1,0,0,${width})`}
        ></circle>
      </svg>
      <div className={`${DEFAULT_CLASSNAME}-icon`} onClick={handleIconClick}>
        <Icon icon={eed_web_icon_global_06_state_cuowu_area} size={iconWidth} />
      </div>
    </div>
  );
};

CircleProgress.defaultProps = {
  width: 48,
  percent: 50,
  strokeColor: 'rgba(0,92,255,1)',
  strokeWidth: 2,
  strokeColorBg: 'rgba(255,255,255,0.5)',
};
